module.exports = __webpack_public_path__ + "img/birdskids.11afc764.jpg";